import { getAuthenticationToken } from './authToken';
import { getEmbedConfig } from './embed/embedConfig';
import { AuthType } from './types';
export const tokenizedFetch = async (input, init) => {
    const embedConfig = getEmbedConfig();
    if (embedConfig.authType !== AuthType.TrustedAuthTokenCookieless) {
        return fetch(input, init);
    }
    const req = new Request(input, init);
    const authToken = await getAuthenticationToken(embedConfig);
    if (authToken) {
        req.headers.append('Authorization', `Bearer ${authToken}`);
    }
    return fetch(req);
};
//# sourceMappingURL=tokenizedFetch.js.map